import type { JSX } from 'react'

import type { Icon } from '.'

export function GridThree({ className, style }: Readonly<Icon>): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height="2191"
      style={style}
      viewBox="0 0 2193 2191"
      width="2193"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="none"
        height="2145.94"
        stroke="black"
        strokeWidth="44"
        width="1000.4"
        x="1169.67"
        y="23.0645"
      />
      <rect
        fill="none"
        height="2145.94"
        stroke="black"
        strokeWidth="44"
        width="1000.4"
        x="22"
        y="23.0645"
      />
    </svg>
  )
}

export default GridThree
